module.exports = __webpack_public_path__ + "static/media/gpx.b427c2cf.png";